module.exports = __webpack_public_path__ + "img/126.2.b025fe66.png";